/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import AudienceModel from 'cio/models/audience';

interface AlertArgs {
  type: string;
  message: AudienceModel['lastError'];
  network: AudienceModel['adNetworkName'];
}

export default class Alert extends Component<AlertArgs> {
  @tracked showDetails = false;
}
